import {useState, useEffect} from 'react';
import {Cell} from './cell.js';

const getScale = (containerWidth, containerHeight, imageWidth, imageHeight) => {  
  const margin = 20;
  const heightScale = (containerHeight - margin) / imageHeight;
  const newImageWidth = imageWidth * heightScale;
  let widthScale = 1;
  if(newImageWidth > containerWidth) {
    widthScale = (containerWidth - margin) / newImageWidth;
  }
  return heightScale * widthScale;
}


const getCellSize = (imageWidth, imageHeight) => {
  const minSize = 40;
  const maxSize = 50;
  let sum = maxSize * 2;
  let k = 0;
  for(let i = minSize; i <= maxSize; i++)
  {
    let result = imageWidth % i + imageHeight % i;    
    if(result < sum) {
      sum = result;
      k = i;
    }     
  }
  return k;
}


const ImageView = ({image, cells, onload, onCellClick}) => {  
  const [containerSizes, setContainerSizes] = useState({width: 0, height: 0});  
  const imageLenght = image == null ? 0 : image.length;
  const [imageSizes, setImageSizes] = useState({width: 0, height: 0, imageHash: 0, realWidth: 0, realHeight: 0, cellSize: 25});
  
  useEffect(() => {
    const imageDiv = document.getElementById("imageDivId");
    setContainerSizes({width: imageDiv.offsetWidth, height: imageDiv.offsetHeight});    
    }, [containerSizes.width, containerSizes.height]);
  
  if(containerSizes.width > 0 && (imageSizes.imageHash !== imageLenght || imageSizes.width === 0)) {
    const imageObject = new Image();
    imageObject.src = image;
    imageObject.onload = () => {
      const finalScale = getScale(containerSizes.width, 
                                  containerSizes.height, 
                                  imageObject.naturalWidth, 
                                  imageObject.naturalHeight);
      const realWidth = imageObject.naturalWidth * finalScale;
      const realHeight = imageObject.naturalHeight * finalScale;  
      const size = getCellSize(realWidth, realHeight);
      setImageSizes({width: imageObject.naturalWidth, 
                    height: imageObject.naturalHeight, 
                    imageHash: imageLenght,
                    realWidth: realWidth,
                    realHeight: realHeight,
                    cellSize: size});      
      const columns = Math.floor(realWidth / size);
      const rows = Math.floor(realHeight / size);
      onload({columns, rows});     
    }
  } 

  return (<div id="imageDivId" className="imageDiv">    
    <svg width={imageSizes.realWidth} height={imageSizes.realHeight} >
      <image href={image} width={imageSizes.realWidth} height={imageSizes.realHeight}/>
        {
          cells && cells.map((row, i) => row.map((cell, j) => <Cell key={`${i}_${j}`} size={imageSizes.cellSize} color={cell} column={i} row={j} onClick={onCellClick}/>))
        }
    </svg>
  </div>);
}

export {ImageView};